<template>
    <div class="main-container">
        <NavBar/>
        <div class="page">
            <TitleBar @back="handleBackEvent">
                <FilterField @filter="handleFilter" class="list-filter"></FilterField>
            </TitleBar>
            <div class="page-view" :class="{lockScroll:showLoadingLightForScrollLock}">
                <LoadingLight id="list"></LoadingLight>
                <slot></slot>
            </div>
            <ToolBar>
                <div slot="left">
                    <slot name="toolbarLeft"></slot>
                </div>
                <div slot="center">
                    <slot name="toolbarCenter"></slot>
                </div>
                <slot name="toolbar"></slot>
            </ToolBar>
        </div>
    </div>

</template>

<script>
    import NavBar from '@c/ui/Navbar'
    import TitleBar from '@c/ui/TitleBar'
    import ToolBar from '@c/ui/ToolBar'
    import FilterField from '@c/ui/Filter'
    import LoadingLight from '@c/ui/LoadingLight'

    import {mapState,mapGetters} from 'vuex'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            TitleBar,
            ToolBar,
            FilterField,
            LoadingLight,
            NavBar
        },
        computed: {
            ...mapGetters({
                showLoadingLightForScrollLock: 'UI/showLoadingLightForScrollLock'
            })
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {
            handleFilter(value){
                this.$emit('filter',value);
            },
            handleBackEvent(){
                this.$emit('back');
            }
        },
        mounted: function () {

        },
        name: 'LayoutBase',
        props: {},
        updated: function () {

        },
        watch: {
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/layouts/List.vue